import { render, staticRenderFns } from "./PCService.vue?vue&type=template&id=4d7a5968&scoped=true&"
import script from "./PCService.vue?vue&type=script&lang=js&"
export * from "./PCService.vue?vue&type=script&lang=js&"
import style0 from "./PCService.vue?vue&type=style&index=0&id=4d7a5968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7a5968",
  null
  
)

export default component.exports